import React from "react";
import '../App.css';

// import loader from '../images/sample_loader_img.gif';

function PageLoader() {

    // const styles = {
    //     position: "absolute",
    //     top: "50%",
    //     left: "50%",
    //     width: "80px",
    //     height: "80px",
	//     transform: "translate(-50%, -50%) rotate(45deg) translate3d(0,0,0)",
    // }

    return (
        <div className="loader">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>

        // <div style={styles}>
        //     <img src={loader}/>
        // </div>
    );
}

export default PageLoader;